<template>
  <form @submit.prevent="handleSubmit" :class="{ 'form-submitting': isSubmitting }">
    <slot></slot>
  </form>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: 'POST'
    },
    onSuccess: {
      type: Function,
      default: null
    },
    onError: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      isSubmitting: false
    };
  },
  methods: {
    async handleSubmit() {
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      const formData = new FormData(this.$el);
      
      // For PUT/PATCH/DELETE, use method spoofing (Laravel standard)
      if (['PUT', 'PATCH', 'DELETE'].includes(this.method.toUpperCase())) {
        formData.append('_method', this.method.toUpperCase());
      }
      
      try {

        const response = await axios({
          url: this.action,
          method: ['PUT', 'PATCH', 'DELETE'].includes(this.method.toUpperCase()) ? 'POST' : this.method,
          data: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        // Show success notification
        if (response.data.message) {
          this.$toast.success(response.data.message);
        }
        
        // Clear saved itemId from session to prevent sidebar from reopening
        window.dispatchEvent(new CustomEvent('clear-vue-table-item-id'));
        
        // Close sidebar
        window.dispatchEvent(new Event('sidebar:close'));
        
        // Reload all components
        window.dispatchEvent(new Event('reload-all-component'));

        // Reload Livewire components listening for the same event name
        if (window.Livewire && typeof window.Livewire.emit === 'function') {
          window.Livewire.emit('reload-all-component');
        } else if (window.livewire && typeof window.livewire.emit === 'function') {
          window.livewire.emit('reload-all-component');
        }
        
        // Call custom success handler if provided
        if (this.onSuccess) {
          this.onSuccess(response.data);
        }
        
        // Emit success event
        this.$emit('success', response.data);
        
      } catch (error) {
        // Handle validation errors
        if (error.response?.status === 422 && error.response?.data?.errors) {
          const errors = error.response.data.errors;
          const firstError = Object.values(errors)[0][0];
          this.$toast.error(firstError);
        } else {
          // Handle other errors
          const message = error.response?.data?.message || 'An error occurred';
          this.$toast.error(message);
        }
        
        // Call custom error handler if provided
        if (this.onError) {
          this.onError(error.response?.data);
        }
        
        // Emit error event
        this.$emit('error', error.response?.data);
        
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>

<style scoped>
.form-submitting {
  pointer-events: none;
  position: relative;
}

.form-submitting::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
}
</style>
